/**
 * 判断是否有效字符，即可见字符
 */
export const validText = (rule, value, callback) => {
  if (value.trim().length === 0) {
    callback(new Error(`必填`));
  } else {
    callback();
  }
};

/**
 * 判断是否非0金额
 */
export const validNonZeroMoney = (rule, value, callback) => {
  if (Number(value) > 0) {
    callback();
  } else {
    callback(new Error("金额需要大于0"));
  }
};

/**
 * 判断是否有重复项
 */
export const validRepeat = (rule, value, callback) => {
  const list = value.trim().split(/\D+/).filter(Boolean);
  const { size } = new Set(list);
  if (list.length !== size) {
    callback(new Error("包含重复项"));
  } else {
    callback();
  }
};

/**
 * 判断是否全部上传成功
 */
export const validUploadSuccess = (rule, value, callback) => {
  if (value.some((item) => item.status === "uploading")) {
    callback(new Error(`图片正在上传中，请稍后`));
  } else if (value.some((item) => item.status === "error")) {
    callback(new Error(`存在图片上传失败，请检查`));
  } else {
    callback();
  }
};



// WEBPACK FOOTER //
// ./src/utils/tools/validator.js